import { NavLink } from "react-router-dom";
import styles from "./LinkComponent.module.css";

import { useActiveLink } from "../../Hooks/active-link-hook";

import { useRoutingHook } from "../../Hooks/routing-hook";
import { useRetailerLinks } from "../../Hooks/retailer-hook";



export const LinkComponent = ({
    type = 'default',
    linkText,
    href,
    externalLinkHandler,
    trackedLink = false,
    children,
}) => {

    const { setIsRoutingState } = useRoutingHook();
    const { generateLink } = useRetailerLinks();


    const handleLinkClick = () => {
        setIsRoutingState(prevState => ({ ...prevState, isNavLinkClicked: true }));

    }

    // Dynamically generate the href based on the retailer context
    const generatedHref = generateLink(href);
    // console.log('GEN HREF',generatedHref)

    const isActive = useActiveLink(href);

    const linkTypes = {
        trackedLinks: styles.trackedLinks,
        footerLinks: styles.footerLinks,
        navTitleText:styles.navTitleText,
        default: styles.defaultText,
    };

    const textType = linkTypes[type] || linkTypes.default;


    ;

    return (

        <NavLink
            to={generatedHref} // Use the dynamically generated href
            // to={href}
            className={`${textType} ${isActive && trackedLink === true ? styles.active : ''}`}
            onClick={externalLinkHandler ? externalLinkHandler : handleLinkClick}
        >
            {linkText && linkText}
            {children}
         
        </NavLink>
    );
};
